import { createAuth } from 'vue-auth3'
import authBearerToken from 'vue-auth3/drivers/auth/bearer-token'
import api from '../axios'

import router from '../router'

export const auth = createAuth({
  fetchData: {
    url: '/auth/user',
  },
  refreshToken: {
    url: '/auth/refresh',
    enabled: true,
  },
  logoutData: {
    url: '/auth/logout',
    redirect: '/auth/login',
  },
  loginData: {
    url: '/auth/login',
    staySignedIn: true,
    fetchUser: true,
  },
  plugins: {
    router,
  },
  drivers: {
    http: {
      request: api,
    },
    auth: authBearerToken,
  },
  authRedirect: 'auth/login',
  rolesKey: 'view_permissions',
  tokenDefaultKey: 'auth_access_token',
})
